import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/medical-service-provider/assign-list`;

export const assigned = {
  getAll: () => generateApiPath(pathBase),
};
